"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _StepContext = _interopRequireDefault(require("../Step/StepContext"));
var _StepIcon = _interopRequireDefault(require("../StepIcon"));
var _StepperContext = _interopRequireDefault(require("../Stepper/StepperContext"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _stepLabelClasses = _interopRequireWildcard(require("./stepLabelClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, orientation = ownerState.orientation, active = ownerState.active, completed = ownerState.completed, error = ownerState.error, disabled = ownerState.disabled, alternativeLabel = ownerState.alternativeLabel;
    var slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, _composeClasses.default)(slots, _stepLabelClasses.getStepLabelUtilityClass, classes);
};
var _obj;
var StepLabelRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})((_obj = {
    display: 'flex',
    alignItems: 'center'
}, _define_property(_obj, "&.".concat(_stepLabelClasses.default.alternativeLabel), {
    flexDirection: 'column'
}), _define_property(_obj, "&.".concat(_stepLabelClasses.default.disabled), {
    cursor: 'default'
}), _define_property(_obj, "variants", [
    {
        props: {
            orientation: 'vertical'
        },
        style: {
            textAlign: 'left',
            padding: '8px 0'
        }
    }
]), _obj));
var StepLabelLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: function(props, styles) {
        return styles.label;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var _obj;
    return _object_spread_props(_object_spread({}, theme.typography.body2), (_obj = {
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        })
    }, _define_property(_obj, "&.".concat(_stepLabelClasses.default.active), {
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: 500
    }), _define_property(_obj, "&.".concat(_stepLabelClasses.default.completed), {
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: 500
    }), _define_property(_obj, "&.".concat(_stepLabelClasses.default.alternativeLabel), {
        marginTop: 16
    }), _define_property(_obj, "&.".concat(_stepLabelClasses.default.error), {
        color: (theme.vars || theme).palette.error.main
    }), _obj));
}));
var StepLabelIconContainer = (0, _zeroStyled.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: function(props, styles) {
        return styles.iconContainer;
    }
})(_define_property({
    flexShrink: 0,
    display: 'flex',
    paddingRight: 8
}, "&.".concat(_stepLabelClasses.default.alternativeLabel), {
    paddingRight: 0
}));
var StepLabelLabelContainer = (0, _zeroStyled.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: function(props, styles) {
        return styles.labelContainer;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _define_property({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary
    }, "&.".concat(_stepLabelClasses.default.alternativeLabel), {
        textAlign: 'center'
    });
}));
var StepLabel = /*#__PURE__*/ React.forwardRef(function StepLabel(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    var children = props.children, className = props.className, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, iconProp = props.icon, optional = props.optional, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, StepIconComponentProp = props.StepIconComponent, StepIconProps = props.StepIconProps, other = _object_without_properties(props, [
        "children",
        "className",
        "componentsProps",
        "error",
        "icon",
        "optional",
        "slots",
        "slotProps",
        "StepIconComponent",
        "StepIconProps"
    ]);
    var _React_useContext = React.useContext(_StepperContext.default), alternativeLabel = _React_useContext.alternativeLabel, orientation = _React_useContext.orientation;
    var _React_useContext1 = React.useContext(_StepContext.default), active = _React_useContext1.active, disabled = _React_useContext1.disabled, completed = _React_useContext1.completed, iconContext = _React_useContext1.icon;
    var icon = iconProp || iconContext;
    var StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) {
        StepIconComponent = _StepIcon.default;
    }
    var ownerState = _object_spread_props(_object_spread({}, props), {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            stepIcon: StepIconProps
        }, componentsProps, slotProps)
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('root', {
        elementType: StepLabelRoot,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className)
    }), 2), RootSlot = _ref[0], rootProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('label', {
        elementType: StepLabelLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), LabelSlot = _ref1[0], labelProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('stepIcon', {
        elementType: StepIconComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), StepIconSlot = _ref2[0], stepIconProps = _ref2[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            icon || StepIconSlot ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIconSlot, _object_spread({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, stepIconProps))
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LabelSlot, _object_spread_props(_object_spread({}, labelProps), {
                        className: (0, _clsx.default)(classes.label, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
process.env.NODE_ENV !== "production" ? StepLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * In most cases will simply be a string containing a title for the label.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: _propTypes.default.shape({
        label: _propTypes.default.object
    }),
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: _propTypes.default.bool,
    /**
   * Override the default label of the step icon.
   */ icon: _propTypes.default.node,
    /**
   * The optional node to display.
   */ optional: _propTypes.default.node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        label: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        stepIcon: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        label: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        stepIcon: _propTypes.default.elementType
    }),
    /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ StepIconComponent: _propTypes.default.elementType,
    /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ StepIconProps: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
StepLabel.muiName = 'StepLabel';
var _default = exports.default = StepLabel;
